import { FetchHttpRequest, FetchRequestOptions } from "http-repository-cache";
import {
  createDefaultHttpClient,
  HttpClient,
} from "@/details/data/backend/rest/http/HttpClient";

/**
 * Factory for creating HTTP clients with consistent configuration
 * Ensures all HTTP clients across the application use the same configuration
 */
export class HttpClientFactory {
  private static instance: HttpClientFactory;
  private httpClient: HttpClient | null = null;

  private constructor() {}

  public static getInstance(): HttpClientFactory {
    if (!HttpClientFactory.instance) {
      HttpClientFactory.instance = new HttpClientFactory();
    }
    return HttpClientFactory.instance;
  }

  /**
   * Get or create the singleton HTTP client instance
   * This ensures we reuse the same HTTP client across the application
   */
  public getHttpClient(): HttpClient {
    if (!this.httpClient) {
      const fetchHttp = new FetchHttpRequest<FetchRequestOptions>();
      this.httpClient = createDefaultHttpClient(fetchHttp);
    }
    return this.httpClient;
  }

  /**
   * Create a new HTTP client instance (useful for testing or special cases)
   */
  public createHttpClient(): HttpClient {
    const fetchHttp = new FetchHttpRequest<FetchRequestOptions>();
    return createDefaultHttpClient(fetchHttp);
  }

  /**
   * Reset the singleton instance (useful for testing)
   */
  public reset(): void {
    this.httpClient = null;
  }
}

export default HttpClientFactory;
